Application.DatePicker = {
    ui: {
        date: '.js-cal-date'
    },
    ready: function () {

        //init datepicker
        flatpickr.l10ns.default.firstDayOfWeek = 1;
        flatpickr(this.ui.date, {dateFormat: "Y/m/d",disableMobile: "true"});

    }
};